export async function putFileToPresignedUrl(uploadUrl, file, contentType) {
    const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': contentType,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to upload lineage file (${response.status})`);
    }
}
